import * as React from 'react';

import SuperCritical from 'lib/supercritical';

import { InPortOps } from 'portcall/inportops/model';

import { AddPortCallBerthsTab } from './berths';

import { InPortOpsView } from 'portcall/inportops/view';
import { PortCallScheduleHeaderView } from 'portcall/portcallschedule/view';

export const AddPortCallBerthsTabView = SuperCritical(({ model: m } : { model : AddPortCallBerthsTab }) =>
    <div className="addportcallberthstab">
        <PortCallScheduleHeaderView className="schedule-header" model={m.ScheduleHeader} />
        {m.PortOps().map((ops, i) =>
            <InPortOpsView model={ops} includeChrome includeInstructions key={OpsKey(ops)} tabIndex={i*3} autoFocus={i == 0 ? true : false} isAddPortCall={true} />
        )}
    </div>
);

let nextOpsKey = 0;
const OPS_KEYS = new WeakMap<InPortOps, number>();
function OpsKey(ops : InPortOps) {
    let id = OPS_KEYS.get(ops);
    if (id === undefined) {
        id = nextOpsKey++;
        OPS_KEYS.set(ops, id);
    }
    return id;
}



// WEBPACK FOOTER //
// ./apps/portcall/addportcall/berthsview.tsx